module.exports = __webpack_public_path__ + "static/media/su-2.6c30b511.jpg";